const TYPES = Object.freeze({
  OPENTEXT: 3,
  NUMERICALTEXT: 7,
  SIMPLEVERTICAL: 5,
  SIMPLEHORIZONTAL: 6,
  SIMPLEWITHCHILD: 9,
  MULTIPLEVERTICAL: 10,
  MULTIPLEHORIZONTAL: 11,
});

export default TYPES;
